var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-icon',{staticClass:"mb-1",class:{
      summaryIcon:
        _vm.clickedSummaryCard && _vm.clickedSummaryCard.topic === _vm.item.topic && _vm.clickedSummaryTimestamp === _vm.item.timestamps,
    },staticStyle:{"font-size":"20px","text-shadow":"0px 0px 3px rgb(26, 39, 46)"},attrs:{"color":_vm.iconColor},on:{"click":function($event){return _vm.onClickSummaryIcon(_vm.item)}}},[_vm._v("\n    "+_vm._s('mdi-bookmark')+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }